module.exports = __webpack_public_path__ + "static/media/aderir.acc4e91e.jpg";